import React, { useEffect, useState } from 'react'

import CardNominee from '../../Common/Cards/CardNominee';


import { useParams } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Nominee() {
  const { id } = useParams();

  const [nomData, setNomData] = useState([]);
  const [votePackages, setVotePackages] = useState([]);

  const [isLoading, setLoading] = useState(false);


  useEffect(() => {

    fetch(`https://hstonline.tech/hstsms/api/v1/nominees/${id}`)
      .then(response => response.json())
      .then(data => {
        console.log('Fetched nominees data:', data);
        setNomData(data.data);

        fetch(`https://hstonline.tech/hstsms/api/v1/votePackages/${data.data.programId}`)
          .then(response => response.json())
          .then(data => {
            console.log('Fetched votePackages data:', data);
            setVotePackages(data);
          })
          .catch(error => {
            console.error('Error fetching votePackages data:', error);
          });

      })
      .catch(error => {
        console.error('Error fetching nominees data:', error);
      });
  }, []);

  console.log('nomData:', nomData);

  // nomData =  JSON.stringify(nomData)

  useEffect(() => {
    setState(prevState => ({ ...prevState, nominee: nomData }));
  }, [nomData]);


  const [state, setState] = useState({
    votes: 0, cedi: 0, dollar: 0, num_votes: null, network: '',
    code: '', phoneNumber: '',
    nominee: nomData

  })



  const [paymentType, setPaymentType] = useState('card')

  const handleOptionChange = (event) => {
    setPaymentType(event.target.value);
  };




  useEffect(() => {
    setState({
      ...state,
      cedi: state.nominee.voteCost * state.num_votes,
      dollar: state.cedi / state.nominee.dollarRate,

    })
  }, [state.num_votes, state.cedi])




  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);
    const dataToSend = {
      num_of_votes: state.num_votes,
      network: state.network,
      phoneNumber: state.phoneNumber,
      code: state.nominee.code,
      //  callback_url: `https://umbgta.hstonline.tech/nominee/${id}`
      callback_url: `https://wnmfpa.hstonline.tech/nominee/${id}`

    };
    //


    // if (paymentType == 'card'){

    //fetch('http://127.0.0.1:8000/api/v1/voteOnline',
    fetch('https://hstonline.tech/hstsms/api/v1/voteOnline',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      })
      .then(response => response.json())
      .then(data => {
        console.log('Form submitted:', data);
        if (data.status === "success") {
          toast.success(data.message);
          const checkout_url = data.url;
          window.location.href = checkout_url;
        }
        else {
          toast.error(data.message)
        }
        // Handle the response data as needed

      })
      .catch(error => {
        console.error('Error submitting form:', error);
      })


      .finally(() => {
        setLoading(false);
      });
  }


  // else{

  //       fetch('https://hstonline.tech/hstsms/api/v1/vote', 
  //       {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(dataToSend)
  //       })
  //         .then(response => response.json())
  //         .then(data => {
  //           console.log('Form submitted:', data);
  //           if (data.status === "success")
  //           {
  //               toast.success(data.message);
  //               // const checkout_url = data.url;
  //               // window.location.href = checkout_url;
  //           }
  //         else{
  //               toast.error(data.message)
  //         }
  //           // Handle the response data as needed

  //         })
  //         .catch(error => {
  //           console.error('Error submitting form:', error);
  //         })


  //         .finally(() => {
  //           setLoading(false);
  //         });
  //     };


  // }



  return (
    <section className='nominee m-auto py-14 flex justify-center items-start page'>
      <div className='sideone' style={{}}>
        <div className="w-full" style={{ height: '80%' }}>
          <CardNominee hideBtn data={state.nominee} />
        </div>
        <ToastContainer />

      </div>

      <form action="" className='px-4 w-1/2' onSubmit={handleSubmit}>
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 mb-6">
          {/* USSD Voting Header */}
          <div className='mb-6 pb-6 border-b border-gray-200'>
            <h2 className='text-2xl font-bold text-gray-800'>Dial *928*085# for USSD Voting</h2>
          </div>

          {/* Number of Votes Input */}
          <div className="mb-6">
            <label htmlFor="num_votes" className='block text-sm font-semibold text-gray-700 mb-2'>
              Number of Votes
            </label>
            <input
              id="num_votes"
              value={state.num_votes}
              onChange={(e) => setState({ ...state, num_votes: e.target.value })}
              type="number"
              min="1"
              placeholder='Enter number of votes'
              className='w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200'
              required
            />
          </div>

          {/* Network and Phone Number Section */}
          <div className="flex flex-wrap gap-4">
            {paymentType !== 'card' && (
              <div className="flex-1 min-w-[200px]">
                <label htmlFor="network" className='block text-sm font-semibold text-gray-700 mb-2'>
                  Network Provider
                </label>
                <select
                  name="network"
                  id="network"
                  className='w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white'
                  onChange={(e) => setState({ ...state, network: e.target.value })}
                  required
                >
                  <option value="">Select Network</option>
                  <option value="MTN">MTN</option>
                  <option value="ATL">AirtelTigo</option>
                  <option value="VDF">Vodafone</option>
                </select>
              </div>
            )}

            <div className="flex-1 min-w-[200px]">
              <label htmlFor="phoneNumber" className='block text-sm font-semibold text-gray-700 mb-2'>
                Mobile Number
              </label>
              <input
                id="phoneNumber"
                onChange={(e) => setState({ ...state, phoneNumber: e.target.value })}
                className='w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200'
                type="tel"
                placeholder='Enter phone number'
                name='phoneNumber'
                required
              />
            </div>

            <input type="hidden" value={state.nominee.code} name="code" />
          </div>
        </div>

        {/* Submit Button */}
        <div className="w-full">
          <button
            className="w-full bg-[#121213] h-14 hover:bg-gray-800 active:bg-gray-900 text-white font-bold rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md hover:shadow-lg"
            disabled={isLoading}
            type="submit"
          >
            {isLoading ? (
              <span className='flex items-center justify-center'>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading...
              </span>
            ) : (
              'Vote Now'
            )}
          </button>
        </div>
      </form>
    </section>
  )
}

export default Nominee